const getStringAbbreviation = (str?: string) => {
  if (!str) return undefined;

  return str
    .match(/\b([A-Za-z0-9])/g)
    ?.join('')
    .toUpperCase();
};
export { getStringAbbreviation };
